import { React, useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const Australia = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Country"    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Country"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const countries = [
        {
            img: "images/free-building-icon.png", universityname: "Queensland University of Technology (QUT)", location: "Brisbane City, Queensland, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$30,200", para2: "NA", para3: "190"
        },
        {
            img: "images/charles-sturt-university-bathhurst.jpg", universityname: "Charles Sturt University", location: "New South Wales, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$24,912", para2: "NA", para3: "801-1000"
        },
        {
            img: "images/victoria-university.jpg", universityname: "Victoria University", location: "Footscray, Victoria, Melbourne", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$33,200", para2: "NA", para3: "601-650"
        },
        {
            img: "images/swinburne-university.jpg", universityname: "Swinburne University of Technology", location: "Hawthorn, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$31,200", para2: "NA", para3: "286"
        },
        {
            img: "images/edith-cowen-university.jpg", universityname: "Edith Cowan University (ECU)", location: "Joondalup, Western Australia, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$34,054", para2: "NA", para3: "651"
        },
        {
            img: "images/University_of_New.png", universityname: "The University of New South Wales (UNSW)", location: "Sydney , New South Wales, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$46,220", para2: "NA", para3: "19"
        },
        {
            img: "images/monash-university.jpg", universityname: "Monash University", location: "Clayton, Victoria, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$38,900", para2: "NA", para3: "42"
        },
        {
            img: "images/free-building-icon.png", universityname: "The University of Queensland (UQ)", location: "Queensland, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$41,958", para2: "NA", para3: "43"
        },
        {
            img: "images/central-queensland-university.jpg", universityname: "Central Queensland University", location: "Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$29,520", para2: "NA", para3: "601-650"
        },
        {
            img: "images/free-building-icon.png", universityname: "Australian National University (ANU)", location: "Canberra, Australia", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$42,960", para2: "NA", para3: "34"
        }
    ]
    return (
        <>
            <BannerBreadcrumb head={"Universities in Australia for International Students"} pagename={"Australia"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">Australia: An Exemplary Center for Foreign Students</h5>
                            <p className="loan-elegibility-des">Because of its world-renowned universities, variability of cultures, and wonderful educational standards, Australia is one of the most desirable countries for international students. Highest-ranking programs offered by universities like the Australian National University, the University of Melbourne, and the University of Sydney draw scholars from all over the world. Students get access to innovative research, business partnerships, and distinctive learning opportunities in a dynamic learning environment. Australian institutions guarantee top-notch instruction in a multicultural environment, whether learners are interested in undergraduate, graduate, or research programs.</p>
                            <h5 className="about-head">Credere Makes Financial Support Easy</h5>
                            <p className="loan-elegibility-des">In Australia, going to university might be very expensive, but Credere is here to help you realize your goals. International students may select the best loan solutions from reputable financial organizations with the assistance of Credere. Students may quickly explore and contrast different educational loans by using our platform, allowing students to choose the best financing choice for their unique needs and objectives.</p>
                            <h5 className="about-head">Providing You with Flexible Loan Options to Strengthen Your Future</h5>
                            <p className="loan-elegibility-des">Securing funding for education is made easy and transparent with Credere. By providing you with valuable data and insights, our platform empowers you to make informed financial choices. We make sure you obtain the ideal loan to support your objectives of studying in Australia, whether those needs be for tuition, living costs, or travel.</p>
                            <h5 className="about-head mb-4">Explore Our List of Australia Universities</h5>
                            <div className="row">
                                {countries.map((item, index) => (
                                    <div className="col-md-6">
                                        <div className="scholar-card">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <img src={item.img} alt="University Images" className="img-fluid countryimg" />
                                                </div>
                                                <div className="col-md-9 d-block my-auto">
                                                    <h5 className="scholar-head">{item.universityname}</h5>

                                                </div>
                                                <p className="scholar-des mb-0 mt-4" style={{ marginLeft: "-6px", fontSize: "16px" }}><LocationPinIcon /> {item.location}</p>
                                                <div className="col-md-12 mt-3">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head1}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para1}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head2}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para2}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head3}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades mb-0">{item.para3}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Australia;